import { render, staticRenderFns } from "./ReadInstitutional.vue?vue&type=template&id=4b152566&scoped=true"
import script from "./ReadInstitutional.vue?vue&type=script&lang=js"
export * from "./ReadInstitutional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b152566",
  null
  
)

export default component.exports